import React, { useContext } from 'react';
import './layout.css';
import Layout from './TahoraUI/Layout';
import { RequestDemoContext } from '../context/RequestDemoContext';

const PricingFooter = ({
  body,
  allPriceInfo,
  heroImage,
  allFooterInfo,
  allFooterInfoA,
  footerInfo,
}) => {
  const { openModal } = useContext(RequestDemoContext);
  return (
    <Layout>
      <div
        style={{ background: '#E5F1F8' }}
        class="-mt-10 lg:mt-0 h-2/4 relative"
      >
        <main class="lg:relative">
          <div
            style={{ maxWidth: '1200px' }}
            class="flex lg:flex-row flex-col mx-auto w-full pb-8 lg:pb-48 text-left lg:text-left"
          >
            <div class="lg:w-1/2 w-full px-4 h-1/2 lg:h-full sm:px-8 xl:pr-16">
              <div class="lg:mt-36 mt-8 mb-8">
                <div class="startedheader max-w-md lg:mx-auto md:mt-5 md:max-w-3xl xl:mr-28">
                  Get Started
                </div>
                <div class="startedtext max-w-md mt-8 md:mt-10 md:max-w-4xl xl:mr-10">
                  Get in touch to book a demo of Tahora with your company or
                  download the app now!
                </div>
                <div class="inline-flex rounded-full w-5/12 lg:mb-5 lg:w-6/12 mt-12 lg:mt-10 flex justify-center border-solid border-2 borderbttn btnText buttonhov1 ">
                  <a
                    href="#"
                    onClick={openModal}
                    class="inline-flex items-center bluenorm justify-center px-4 py-3 border border-transparent text-base font-medium rounded-full "
                  >
                    <div className=" btnText"> Book a demo</div>
                  </a>
                </div>
                <div class="flex mt-7 flex-row max-w-md pr-4">
                  <a
                    href={allFooterInfoA.apple_app_store_link.url}
                    class="w-1/2 lg:w-1/3"
                  >
                    {' '}
                    <img
                      class="w-full"
                      src={allFooterInfoA.apple_app_store_badge.url}
                      alt=""
                    />
                  </a>
                  <a
                    href={allFooterInfoA.google_play_store_link.url}
                    class="w-1/2 lg:w-1/3 ml-4"
                  >
                    {' '}
                    <img
                      class="w-full"
                      src={allFooterInfoA.google_play_store_badge.url}
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>

            <div
              style={{ height: '100%' }}
              class="backgP lg:w-1/2 h-1/2 lg:h-full top-0 w-full h-64 sm:h-72 md:h-96 minfoot"
            >
              <div class="relative block lg:pr-8 lg:pl-0 lg:pt-0 lg:pb-0  p-4 lg:p-8 align2 max-w-xl z-1 rounded-lg -mt-4 pb-4 lg:pb-0 lg:mt-28 mx-auto overflow-hidden">
                <img
                  class="w-full "
                  src={allPriceInfo.footer_image.url}
                  alt=""
                />
              </div>
            </div>
          </div>
        </main>
      </div>
    </Layout>
  );
};

export default PricingFooter;
